<template>
<div class="ad-root" :style="themePageStyle">

  <nav class="ad-topbar"><div class="container d-flex align-items-center justify-content-between py-2">
    <div class="d-flex align-items-center" style="gap:12px;">
      <a href="javascript:void(0)" @click="$router.push('/learn')"><i class="mdi mdi-arrow-left" style="color:var(--fm-m,#A09888);font-size:22px;"></i></a>
      <a href="javascript:void(0)" @click="$router.push('/')"><img src="assets/images/flockr_logo.png" alt="Flockr" style="height:30px;" /></a>
      <span class="fw-semibold" style="color:var(--fm-h,#F5F0E8);font-size:14px;">Learning Hub</span>
    </div>
    <button class="btn btn-sm btn-warning" @click="$router.push('/learn')"><i class="mdi mdi-book-multiple me-1"></i>All Articles</button>
  </div></nav>

  <div class="container ad-container">
    <div v-if="loading" class="text-center py-5"><div class="spinner-border text-warning"></div></div>

    <div v-else-if="!article" class="text-center py-5">
      <i class="mdi mdi-book-cancel-outline" style="font-size:64px;color:var(--fm-s,#3A3530);"></i>
      <h5 class="mt-3" style="color:var(--fm-h,#F5F0E8);">Article not found</h5>
      <p style="color:var(--fm-s,#6B6356);">{{ error || 'It may have been unpublished or removed.' }}</p>
      <button class="btn btn-warning" @click="$router.push('/learn')">Browse all articles</button>
    </div>

    <div v-else>
      <div v-if="article.cover_image_url" class="ad-cover" :style="'background-image:url('+imgUrl(article.cover_image_url)+')'"></div>

      <div class="ad-header">
        <span v-if="article.category_name" class="ad-cat">{{ article.category_name }}</span>
        <h2 class="ad-title">{{ article.title }}</h2>
        <p v-if="article.excerpt" class="ad-excerpt">{{ article.excerpt }}</p>
        <div class="ad-meta">
          <span v-if="article.author_name" style="color:var(--fm-h,#F5F0E8);">By {{ article.author_name.trim() || 'Flockr' }}</span>
          <span v-if="article.published_at"><i class="mdi mdi-calendar me-1"></i>{{ article.published_at.split(' ')[0] }}</span>
          <span><i class="mdi mdi-eye-outline me-1"></i>{{ article.view_count }} view{{ article.view_count===1?'':'s' }}</span>
          <span v-if="article.target_audience"><i class="mdi mdi-school me-1"></i>{{ humanize(article.target_audience) }}</span>
        </div>
      </div>

      <div class="ad-body" v-html="renderedContent"></div>

      <div class="ad-footer">
        <button class="btn btn-outline-warning" @click="$router.push('/learn')">
          <i class="mdi mdi-arrow-left me-1"></i>Back to Learning Hub
        </button>
        <button class="btn btn-warning" @click="$router.push('/forum')">
          <i class="mdi mdi-forum me-1"></i>Discuss in the Forum
        </button>
      </div>
    </div>
  </div>
</div>
</template>

<style>
:root{--fm-h:#F5F0E8;--fm-s:#6B6356;--fm-m:#A09888;--fm-bg1:#141414;--fm-bg2:#0F0F0F;--fm-bg3:#1E1E1E;--fm-br:#1E1E1E}
html[data-theme="light"]{--fm-h:#1A1A1A;--fm-s:#777;--fm-m:#555;--fm-bg1:#FFFFFF;--fm-bg2:#F7F5F2;--fm-bg3:#F0EBE4;--fm-br:#E8E2DA}
html[data-theme="light"] body{background:#F7F5F2!important}
html[data-theme="light"] .ad-root{background:#F7F5F2!important;color:#1A1A1A!important}
html[data-theme="light"] .ad-topbar{background:rgba(255,255,255,.95)!important;border-bottom-color:#E8E2DA!important}
html[data-theme="light"] .ad-body{color:#1A1A1A!important}
</style>

<style scoped>
.ad-root{background:var(--fm-bg2,#0A0A0A);min-height:100vh;color:var(--fm-h,#F5F0E8)}
.ad-topbar{position:sticky;top:0;z-index:100;padding:10px 0;background:var(--fm-bg1,#141414);backdrop-filter:blur(10px);border-bottom:1px solid var(--fm-br,#1E1E1E)}
.ad-container{padding-top:80px;padding-bottom:60px;max-width:780px}
.ad-cover{height:280px;background-size:cover;background-position:center;border-radius:14px;margin-bottom:24px;background-color:var(--fm-bg1,#141414)}
.ad-header{margin-bottom:24px}
.ad-cat{display:inline-block;padding:3px 10px;border-radius:6px;background:rgba(191,161,100,.12);color:#BFA164;font-size:10px;font-weight:700;text-transform:uppercase;letter-spacing:.5px;margin-bottom:10px}
.ad-title{color:var(--fm-h,#F5F0E8);font-weight:700;line-height:1.3;margin-bottom:12px}
.ad-excerpt{color:var(--fm-m,#A09888);font-size:15px;line-height:1.6;margin-bottom:14px;font-style:italic}
.ad-meta{color:var(--fm-s,#6B6356);font-size:12px;display:flex;flex-wrap:wrap;gap:14px}
.ad-body{color:var(--fm-h,#F5F0E8);font-size:15px;line-height:1.8}
.ad-body :deep(h1),.ad-body :deep(h2),.ad-body :deep(h3){color:var(--fm-h,#F5F0E8);margin-top:1.5em;margin-bottom:.5em}
.ad-body :deep(p){margin-bottom:1em;color:var(--fm-h,#F5F0E8)}
.ad-body :deep(ul),.ad-body :deep(ol){margin-bottom:1em;padding-left:1.4em}
.ad-body :deep(li){margin-bottom:.4em}
.ad-body :deep(a){color:#BFA164;text-decoration:underline}
.ad-body :deep(blockquote){border-left:3px solid #BFA164;padding-left:14px;margin:1em 0;color:var(--fm-m,#A09888);font-style:italic}
.ad-body :deep(img){max-width:100%;border-radius:8px;margin:1em 0}
.ad-footer{margin-top:40px;padding-top:20px;border-top:1px solid var(--fm-br,#1E1E1E);display:flex;gap:10px;justify-content:space-between;flex-wrap:wrap}
</style>

<script>
/* eslint-disable */
import { executeJson, flocker, uploads } from "@/api";

export default {
  name: "ArticleDetail",
  data(){return{
    darkMode:(document.documentElement.getAttribute('data-theme')||localStorage.getItem('flockr_theme')||'dark')!=='light',
    themeObserver:null,loading:true,error:'',article:null
  }},
  computed:{
    themePageStyle(){return this.darkMode?'background:#0A0A0A;min-height:100vh;color:#F5F0E8;':'background:#F7F5F2;min-height:100vh;color:#1A1A1A;'},
    renderedContent(){
      // Articles use markdown-ish content with \n\n paragraph breaks. Wrap each paragraph in <p>.
      // If admin authored full HTML (has <p>/<h*>/<ul> tags), pass through unchanged.
      if (!this.article || !this.article.content) return '';
      var c = this.article.content;
      if (/<(p|h[1-6]|ul|ol|table|blockquote|div)/i.test(c)) return c;
      // Plain text: convert ## heading and \n\n paragraphs to HTML
      return c.split(/\n\n+/).map(function(para){
        para = para.trim(); if (!para) return '';
        if (para.indexOf('## ') === 0) return '<h2>' + para.substring(3) + '</h2>';
        if (para.indexOf('# ') === 0)  return '<h1>' + para.substring(2) + '</h1>';
        return '<p>' + para.replace(/\n/g, '<br/>') + '</p>';
      }).join('\n');
    }
  },
  watch: {
    '$route.params.idOrSlug'(){this.load()}
  },
  mounted(){
    this._applyThemeOnce();
    var self=this;
    this.themeObserver=new MutationObserver(function(){try{self._applyThemeOnce();}catch(e){}});
    this.themeObserver.observe(document.documentElement,{attributes:true,attributeFilter:['data-theme']});
    this.load();
  },
  beforeUnmount(){if(this.themeObserver){this.themeObserver.disconnect();this.themeObserver=null}},
  methods:{
    _applyThemeOnce(){
      var current=document.documentElement.getAttribute('data-theme');
      var desired=(localStorage.getItem('flockr_theme')||current||'dark');
      if(current!==desired) document.documentElement.setAttribute('data-theme',desired);
      this.darkMode=desired!=='light';
    },
    imgUrl(u){if(!u)return'';if(u.indexOf('http')===0)return u;return uploads+String(u).replace(/^uploads\//,'');},
    humanize(s){return (s||'').charAt(0).toUpperCase()+ (s||'').slice(1);},
    async load(){
      this.loading=true;this.error='';this.article=null;
      var idOrSlug=this.$route.params.idOrSlug;
      var params={function:'getArticleDetail'};
      if(/^\d+$/.test(idOrSlug)) params.articleId=idOrSlug;
      else params.slug=idOrSlug;
      try{
        var r=await executeJson(params,flocker);
        if(r.data&&r.data.success&&r.data.data&&r.data.data.article){
          this.article=r.data.data.article;
        }else{
          this.error=(r.data&&r.data.message)||'Article not found';
        }
      }catch(e){this.error=(e&&e.message)||'Network error'}
      this.loading=false;
    }
  }
};
</script>
